import React, { useState, useRef, useEffect } from "react";
import { PiStarFill, PiStarThin } from "react-icons/pi";

export default function StarRating({
  sendDataStar,
  pergunta_id,
  notaAtual = 0,
}) {
  const [rating, setRating] = useState(notaAtual);
  const [poppedStar, setPoppedStar] = useState(null);
  const starContainerRef = useRef(null);

  const totalStars = 5;

  useEffect(() => {
    setRating(notaAtual);
  }, [notaAtual]);

  const calculateRatingFromPosition = (event) => {
    const rect = starContainerRef.current.getBoundingClientRect();
    const x = event.type.includes("touch")
      ? event.touches[0].clientX
      : event.clientX;

    let relativeX = x - rect.left;
    if (relativeX < 0) relativeX = 0;
    if (relativeX > rect.width) relativeX = rect.width;

    const newRating = Math.ceil((relativeX / rect.width) * totalStars);

    setRating(newRating);
    sendDataStar(newRating, pergunta_id);
  };

  const handleClick = (starValue) => {
    setRating(starValue);
    sendDataStar(starValue, pergunta_id);

    setPoppedStar(starValue);
    setTimeout(() => setPoppedStar(null), 150);
  };

  return (
    <div
      ref={starContainerRef}
      className="flex space-x-5 select-none"
      style={{ touchAction: "none" }}
      onMouseMove={(e) => e.buttons === 1 && calculateRatingFromPosition(e)}
      onTouchMove={(e) => calculateRatingFromPosition(e)}
    >
      {[...Array(totalStars)].map((_, i) => {
        const starValue = i + 1;
        const isFilled = starValue <= rating;
        const isPopped = poppedStar === starValue;

        return (
          <span
            key={starValue}
            className={`
              cursor-pointer text-[4.5rem] transition-transform transition-colors duration-150 ease-out
              ${isFilled ? "text-yellow-400" : "text-slate-300"}
              ${isPopped ? "scale-150" : "scale-100"}
              hover:scale-125
            `}
            onClick={() => handleClick(starValue)}
          >
            {isFilled ? (
              <PiStarFill style={{ fill: '#ffab0f' }} />
            ) : (
              <PiStarThin />
            )}
          </span>
        );
      })}
    </div>
  );
}
